import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser, setBusiness } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = hash.split("session_id=")[1]?.split("&")[0];
    if (!sid) { nav("/"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        const me = await api.get("/auth/me");
        setUser(me.data.user);
        setBusiness(me.data.business);
        nav(me.data.user.role === "admin" ? "/admin" : "/dashboard", { state: { user: me.data.user } });
      } catch {
        nav("/");
      }
    })();
  }, [nav, setUser, setBusiness]);

  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="text-center">
        <div className="w-10 h-10 border-3 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[color:var(--ink-2)]">Signing you in...</p>
      </div>
    </div>
  );
}
